import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { ExternalLinkComponent } from 'common/components/external-link';
import { useLanguageFilteredList } from 'core/i18n';
import * as apiModel from './social-media.api-model';
import * as classes from './social-media.styles';

export const SocialMediaComponent: React.FC = () => {
  const query = graphql`
    query {
      allContentIslandSocialMedia {
        nodes {
          _language
          type
          url
          image {
            url
          }
        }
      }
    }
  `;

  const { allContentIslandSocialMedia } = useStaticQuery(query);
  const [socialMedia] = useLanguageFilteredList<apiModel.SocialMedia>(allContentIslandSocialMedia.nodes);

  return (
    <div className={classes.socialMediaIcons}>
      {socialMedia.map(item => (
        <ExternalLinkComponent key={item.type} href={item.url}>
          <img src={item.image.url} alt={item.type} className={classes.linkedinIcon} />
        </ExternalLinkComponent>
      ))}
    </div>
  );
};
